import { createSlice } from "@reduxjs/toolkit";

export const branchesSlices = createSlice({
  name: "branchesByBusiness",
  initialState: {
    branchesByBusiness: [],
  },
  reducers: {
    setBranchByBusinress: (state, action) => {
      state.branchesByBusiness = action.payload;
    },
  },
});

export const { setBranchByBusinress } = branchesSlices.actions;

export default branchesSlices.reducer;
